import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";

import { formatFloat, formatRatioPercent, formatRatio } from '../utils';

const styles = theme => ({
  kpiBig: {
    padding: theme.spacing(2, 1),
    textAlign: "flex-start",
    width: '100%',
  },
  kpiSmall: {
    padding: theme.spacing(2, 1),
  },
  fontAndGrey: {
    fontFamily: 'Source Sans Pro, sans-serif',
    color: '#727272',
    fontSize: 13,
    fontWeight: 'normal',
  },
  fontAndBlue: {
    fontFamily: 'Source Sans Pro, sans-serif',
    color: theme.palette.primary.main,
  },
  font: {
    fontFamily: 'Source Sans Pro, sans-serif',
  },
  container: {
    height: "100%",
    padding: "0px 20px",
    shadowBox: 'none',
  }
});

@withStyles(styles)
class KPI extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    value: PropTypes.number,
    unit: PropTypes.string,
    type: PropTypes.string, // big, small
  };

  static defaultProps = {
    description: null,
    value: null,
    unit: null,
    type: 'big'
  };

  render() {
    const {description, name, classes, type} = this.props;
    let { value, unit } = this.props;
    if (unit === '%') {
      value = formatRatioPercent(value);
      unit = null;
    } else if (unit === 'pp') {
      value = formatRatio(value);
    } else {
      value = formatFloat(value);
    }
    return (
        <Tooltip title={description} placement="top">
          <Paper className={classes.kpiBig}>
            {
              type==='big'
                ? (
                  <Grid
                    container
                    direction="column"
                    justify="flex-start"
                    className={classes.container}
                    wrap="nowrap"
                  >
                    <Grid item>
                      <strong>
                        <Typography variant="h4" className={classes.fontAndBlue} noWrap>
                          {value} {unit}
                        </Typography>
                      </strong>
                    </Grid>
                    <Grid item>
                      <Typography variant="subtitle1" className={classes.fontAndGrey}>{name}</Typography>
                    </Grid>
                  </Grid>
                )
                : (
                  <Grid item
                    container
                    justify="space-between"
                    className={classes.container}
                    wrap="nowrap"
                  >
                    <Grid item container alignItems="center">
                      <Typography variant="subtitle1" className={classes.fontAndGrey}>{name}</Typography>
                    </Grid>
                    <Grid item>
                      <strong>
                        <Typography variant="h6" noWrap className={classes.font}>
                          {value} {unit}
                        </Typography>
                      </strong>
                    </Grid>
                  </Grid>
                )
            }
          </Paper>
        </Tooltip>
    );
  }
}

export default KPI;
